<template>
  <div class="row">
    <div class="col">
      <div v-if="isRechercheDataLoading == true" class="row">
        <div class="col">
          <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
        </div>
      </div>
      <div v-else class="row">
        <DataTable
            class="p-datatable-sm"
            :value="suivis"
            :resizableColumns="true"
            columnResizeMode="fit"
            :reorderableColumns="true"
            :sortField="sortField" :sortOrder="sortOrder" @sort="onSort"
            selectionMode="single"
            dataKey="cle"
            @row-select="onRowSelect"
            :paginator="true"
            :rows="100" :rowClass="rowClass"
            paginatorPosition="both"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 30, 100]"
            currentPageReportTemplate="Afficher {first} à {last} sur {totalRecords} suivis"
        >
          <template #empty>
            <div v-if="isRechercheDataLoading == true" class="row">
              <div class="col">
                <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
              </div>
            </div>
            <div v-else class="row">
              &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
            </div>
          </template>
          <Column
              field="numeroDossier"
              header="Numéro Cardex"
              :sortable="true"
          ></Column>
          <Column
            field="typeActiviteAfficher"
            header="Type Activité"
            :sortable="true"
          ></Column>
          <Column
              field="creerParDescription"
              header="Demandeur"
              :sortable="true"
          ></Column>
          <Column
              field="intervenantAfficher"
              header="Intervenant"
              :sortable="true"
          ></Column>
          <Column
              field="texte"
              header="Suivi"
              :sortable="true"
          ></Column>
          <Column
              field="prevue"
              header="Date Prévue"
              :sortable="true">
            <template #body="slotProps">
              {{
                $commun.formatDate(
                    slotProps.data.prevue
                )
              }}
            </template>
          </Column>
          <Column
              field="completee"
              header="Date Complétée"
              :sortable="true">
            <template #body="slotProps">
              {{
                $commun.formatDate(
                    slotProps.data.completee
                )
              }}
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import { ref } from 'vue';

export default {
  name: "ResultatSuivi",
  props: ['suivis', 'isRechercheDataLoading'],
  computed: {
    ...mapGetters({
      suivisHistorique: 'suivi/suivisHistorique',
    })
  },
  setup() {
    const sortField = ref(localStorage.getItem('sortFieldSuivi') || 'numeroDossier');
    const sortOrder = ref(Number(localStorage.getItem('sortOrderSuivi')) || -1);
    const onSort = (event) => {
      sortField.value = event.sortField;
      sortOrder.value = event.sortOrder;
      localStorage.setItem('sortFieldSuivi', event.sortField);
      localStorage.setItem('sortOrderSuivi', event.sortOrder);
    };
    return {
      sortField,
      sortOrder,
      onSort
    };
  },
  methods: {
    onRowSelect(event) {
      this.$store.commit('suivi/AJOUT_SUIVI_HISTORIQUE', event.data.cle);
      this.$router.push({
        name: "dossierConsulter",
        params: {
          cle: event.data.cleReference,
          site: event.data.siteReference,
        },
      });
    },
    rowClass(data) {
      return this.suivisHistorique.includes(data.cle) ? 'row-previously-selected': null;
    },
  },
};
</script>

<style scoped>
::v-deep(.row-previously-selected) {
    color: var(--row-previously-selected) !important;
}
</style>